export default __webpack_public_path__ + "static/media/companies-benefits-02.b005ab74.webp";